import { render, staticRenderFns } from "./Vault2.vue?vue&type=template&id=7c72bc57&"
import script from "./Vault2.vue?vue&type=script&lang=js&"
export * from "./Vault2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports